import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {
  login:'/qywxLogin/',
  getinventory:'/teams/inventory/getshangwuinventory/',
  getproducts:'/teams/products/',
  getcangku:'/teams/cangkus/',
  getfactory:'/teams/factory/',
  add:'/teams/inventory/'

}

export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}

export function getinventory (params) {
  return axios({
    url: api.getinventory,
    method: 'get',
    params
  })
}
export function getproducts (params) {
  return axios({
    url: api.getproducts,
    method: 'get',
    params
  })
}
export function getcangku (params) {
  return axios({
    url: api.getcangku,
    method: 'get',
    params
  })
}
export function getfactory (params) {
  return axios({
    url: api.getfactory,
    method: 'get',
    params
  })
}


export function add (data) {
  return axios({
    url: api.add,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/views/shangwuviews/rukuadd/api.js